import React, { useState } from "react";
import Button, { ButtonColorTypes } from "../shared-components/Button";
import { PencilIcon } from "@heroicons/react/24/outline";

import { AffiliationItemWithMetaData, Item } from "../api/Items";
import ModalAffiliationAdd from "./ModalAffiliationAdd";
import { ReportSummaryItemApi } from "../api/Reports";

type Props = {
  handleAction: (
    action: "edit" | "cancel",
    values: boolean | string[] | undefined
  ) => void;
  item: AffiliationItemWithMetaData;
  report: ReportSummaryItemApi;
  behaviors: string[];
  isAmendment?: boolean;
};

const ButtonWebcontentEdit = ({
  handleAction,
  item,
  report,
  behaviors,
  isAmendment,
}: Props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <Button
        text={
          <div className="flex gap-2 items-center py-0.5 text-gray-500">
            <PencilIcon className="w-5" />
            <span className="text-gray-700 text-xs font-light">Edit</span>
          </div>
        }
        colorType={ButtonColorTypes.cancel}
        onClick={() => {
          setShowModal(true);
        }}
      />
      <ModalAffiliationAdd
        showModal={showModal}
        close={(item?: Item) => {
          if (item) {
            handleAction("edit", [item.external_id]);
          }
          setShowModal(false);
        }}
        initialState={{ report: report, affiliationContent: item }}
        behaviors={behaviors}
        isNew={false}
      />
    </div>
  );
};

export default ButtonWebcontentEdit;
